<template>
  <div class="padded">
    <h1>{{yr}}</h1>

    <table class="el-table">
      <tr v-for="value, key in siteReport">
        <th><span :class="titleClass(key)">{{key}} Sites</span>
          <table style="width: 100%; font-weight: normal;">
            <tr v-for="v, k in value">
              <th width="8%">Period</th>
              <th :width="width">{{v.month1 ? v.month1.slice(0, 3) : ''}}</th>
              <th :width="width">{{v.month2 ? v.month2.slice(0, 3) : ''}}</th>
              <th :width="width">{{v.month3 ? v.month3.slice(0, 3) : ''}}</th>
              <th :width="width">{{v.month4 ? v.month4.slice(0, 3) : ''}}</th>
              <th :width="width">{{v.month5 ? v.month5.slice(0, 3) : ''}}</th>
              <th :width="width">{{v.month6 ? v.month6.slice(0, 3) : ''}}</th>
              <th :width="width">{{v.month7 ? v.month7.slice(0, 3) : ''}}</th>
              <th :width="width">{{v.month8 ? v.month8.slice(0, 3) : ''}}</th>
              <th :width="width">{{v.month9 ? v.month9.slice(0, 3) : ''}}</th>
              <th :width="width">{{v.month10 ? v.month10.slice(0, 3) : ''}}</th>
              <th :width="width">{{v.month11 ? v.month11.slice(0, 3) : ''}}</th>
              <th :width="width">{{v.month12 ? v.month12.slice(0, 3) : ''}}</th>
            </tr>
            <tr v-for="v, k in value">
              <td><b>Sites</b></td>
              <td align="right">{{v.sites1 ? formatInteger(v.sites1) : ''}}</td>
              <td align="right">{{v.sites2 ? formatInteger(v.sites2) : ''}}</td>
              <td align="right">{{v.sites3 ? formatInteger(v.sites3) : ''}}</td>
              <td align="right">{{v.sites4 ? formatInteger(v.sites4) : ''}}</td>
              <td align="right">{{v.sites5 ? formatInteger(v.sites5) : ''}}</td>
              <td align="right">{{v.sites6 ? formatInteger(v.sites6) : ''}}</td>
              <td align="right">{{v.sites7 ? formatInteger(v.sites7) : ''}}</td>
              <td align="right">{{v.sites8 ? formatInteger(v.sites8) : ''}}</td>
              <td align="right">{{v.sites9 ? formatInteger(v.sites9) : ''}}</td>
              <td align="right">{{v.sites10 ? formatInteger(v.sites10) : ''}}</td>
              <td align="right">{{v.sites11 ? formatInteger(v.sites11) : ''}}</td>
              <td align="right">{{v.sites12 ? formatInteger(v.sites12) : ''}}</td>
            </tr>
            <tr v-for="v, k in value">
              <td>Ways</td>
              <td class="text-primary" align="right">{{v.ways1 ? formatInteger(v.ways1, 0) : ''}}</td>
              <td class="text-primary" align="right">{{v.ways2 ? formatInteger(v.ways2, 0) : ''}}</td>
              <td class="text-primary" align="right">{{v.ways3 ? formatInteger(v.ways3, 0) : ''}}</td>
              <td class="text-primary" align="right">{{v.ways4 ? formatInteger(v.ways4, 0) : ''}}</td>
              <td class="text-primary" align="right">{{v.ways5 ? formatInteger(v.ways5, 0) : ''}}</td>
              <td class="text-primary" align="right">{{v.ways6 ? formatInteger(v.ways6, 0) : ''}}</td>
              <td class="text-primary" align="right">{{v.ways7 ? formatInteger(v.ways7, 0) : ''}}</td>
              <td class="text-primary" align="right">{{v.ways8 ? formatInteger(v.ways8, 0) : ''}}</td>
              <td class="text-primary" align="right">{{v.ways9 ? formatInteger(v.ways9, 0) : ''}}</td>
              <td class="text-primary" align="right">{{v.ways10 ? formatInteger(v.ways10, 0) : ''}}</td>
              <td class="text-primary" align="right">{{v.ways11 ? formatInteger(v.ways11, 0) : ''}}</td>
              <td class="text-primary" align="right">{{v.ways12 ? formatInteger(v.ways12, 0) : ''}}</td>
            </tr>
          </table>
        </th>
      </tr>
    </table>
  </div>
</template>


<script>

import ReportMixins from '@/mixins/ReportMixins'
import SiteMixins from '@/mixins/SiteMixins'

export default {
  mixins: [ReportMixins, SiteMixins],

  props: {
    selectedYear: {
      type: Number,
      required: true
    }
  },

  methods: {
    setReportData (reportData) {
      this.rawData = reportData
      console.log('raw data', reportData)

      var item = {}
      var subitem = {}

      var currentType = null
      var lastType = null

      if (this.rawData) {
        for (var p = 0; p < this.rawData.length; p++) {
          currentType = this.rawData[p].status

          if (lastType !== currentType) {
            if (!item[currentType]) {
              item[currentType] = []
            }

            lastType = currentType
            subitem = {}
          }

          subitem['month' + this.rawData[p].month] = this.rawData[p].period
          subitem['sites' + this.rawData[p].month] = Number(this.rawData[p].sites)
          subitem['ways' + this.rawData[p].month] = Number(this.rawData[p].ways)

          item[currentType] = [subitem]
        }  // for

        this.siteReport = item
      }

//      console.log('Site Report: rawData', this.rawData, 'siteReport', this.siteReport)
    }

  },

  watch: {
    selectedYear: function (value) {
      this.yr = value
      this.findSitesReportByYear(this.yr, this.setReportData, this.org().id)
    }
  },

  data () {
    return {
      yr: this.selectedYear,
      width: '8%',
      rawData: [],
      siteReport: []
    }
  },

  created () {
    this.findSitesReportByYear(this.yr, this.setReportData, this.org().id)
  }

}
</script>
